import { useEffect, useState } from "react";
import { Outlet, useNavigate, Link } from "react-router-dom";
import { 
  LayoutDashboard, 
  Scissors, 
  Image, 
  Star, 
  Calendar, 
  Settings, 
  LogOut,
  Menu,
  X
} from "lucide-react";

const sidebarLinks = [
  { name: "Dashboard", icon: LayoutDashboard, tab: "dashboard" },
  { name: "Services", icon: Scissors, tab: "services" },
  { name: "Gallery", icon: Image, tab: "gallery" },
  { name: "Reviews", icon: Star, tab: "reviews" },
  { name: "Bookings", icon: Calendar, tab: "bookings" },
  { name: "Settings", icon: Settings, tab: "settings" },
];

export default function AdminLayout() {
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("admin_token");
    if (!token) {
      navigate("/admin");
    }
  }, [navigate]);

  const handleLogout = () => {
    localStorage.removeItem("admin_token");
    navigate("/admin");
  };

  return (
    <div className="min-h-screen bg-neutral-50 flex" data-testid="admin-layout">
      {/* Mobile Sidebar Toggle */}
      <button
        onClick={() => setSidebarOpen(!sidebarOpen)}
        className="lg:hidden fixed top-4 left-4 z-50 p-2 bg-white rounded-lg shadow-md"
        data-testid="admin-sidebar-toggle"
      >
        {sidebarOpen ? <X size={24} /> : <Menu size={24} />}
      </button>

      {/* Sidebar */}
      <aside
        className={`fixed lg:static inset-y-0 left-0 z-40 w-64 bg-obsidian text-white transform transition-transform duration-300 ${
          sidebarOpen ? "translate-x-0" : "-translate-x-full lg:translate-x-0"
        }`}
        data-testid="admin-sidebar"
      >
        <div className="p-6">
          <Link to="/" className="font-heading text-2xl">
            Illuminate
          </Link>
          <p className="text-xs text-neutral-400 mt-1">Admin Panel</p>
        </div>

        <nav className="px-4 py-6">
          {sidebarLinks.map((link) => (
            <button
              key={link.tab}
              onClick={() => {
                const searchParams = new URLSearchParams(window.location.search);
                searchParams.set("tab", link.tab);
                navigate(`/admin/dashboard?${searchParams.toString()}`);
                setSidebarOpen(false);
              }}
              className="w-full flex items-center gap-3 px-4 py-3 rounded-lg text-sm text-neutral-300 hover:bg-white/10 hover:text-white transition-colors"
              data-testid={`admin-nav-${link.tab}`}
            >
              <link.icon size={18} />
              {link.name}
            </button>
          ))}
        </nav>

        <div className="absolute bottom-0 left-0 right-0 p-4 border-t border-neutral-800">
          <button
            onClick={handleLogout}
            className="w-full flex items-center gap-3 px-4 py-3 rounded-lg text-sm text-neutral-300 hover:bg-red-500/20 hover:text-red-400 transition-colors"
            data-testid="admin-logout-btn"
          >
            <LogOut size={18} />
            Logout
          </button>
        </div>
      </aside>

      {/* Main Content */}
      <main className="flex-1 p-6 lg:p-8 overflow-auto">
        <Outlet />
      </main>

      {/* Overlay for mobile */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 bg-black/50 z-30 lg:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}
    </div>
  );
}
